import { Metrics } from './groupMicrobiomeAgeResponse';

export default function filterNonZeroImpactMetrics(metrics: Metrics) {
  return metrics.filter(m => +(m.contribution_years ?? 0).toFixed(1) !== 0);
}
